export default "__VITE_ASSET__BElSOktV__"